import { render, staticRenderFns } from "./DeleteCategoryModal.vue?vue&type=template&id=65a32dcf&scoped=true&"
import script from "./DeleteCategoryModal.vue?vue&type=script&lang=js&"
export * from "./DeleteCategoryModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteCategoryModal.vue?vue&type=style&index=0&id=65a32dcf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a32dcf",
  null
  
)

export default component.exports